export default "__VITE_ASSET__mJu6BPFP__"